<div class="d-flex flex-column h-100">
	<div class="d-flex flex-column flex-grow-1 align-items-center justify-content-center bg-cover-image">
		<div class="align-self-start mx-auto ms-xl-4 mt-4 mb-auto">
			<button [routerLink]="['/']"
				class="btn btn-outline-white btn-thin d-flex align-items-center">
				<svg-icon [svgClass]="'icon--button'"
					src="assets/images/icon-arrow-left.svg"></svg-icon>
				<span class="ms-3">Homepage</span>
			</button>
		</div>
		<div class="container pb-5 pb-xl-4 mt-5 mt-xl-4 mb-auto">
			<div class="row g-0">
				<div class="col-12 col-md-8 offset-md-2 col-xl-6 offset-xl-3 shadow-lg">
					<div class="d-flex flex-column bg-primary py-5 py-xl-5">
						<div class="d-flex flex-column my-auto">
							<div class="d-flex flex-column justify-content-center text-center">
								<svg-icon [svgClass]="'logo--text'"
									src="assets/images/ys-logo-text-reversed.svg"></svg-icon>
							</div>
						</div>
					</div>
					<div class="d-flex flex-column align-items-center bg-white">
						<div class="w-100 p-4 p-lg-5">
							<div class="text-center mb-4">
								<svg-icon [svgClass]="'icon--status'"
									src="assets/images/icon-circle-check-blue.svg"></svg-icon>
								<h2 class="mt-4 mb-5 header-text">
									Welcome to Yorkstone Loyalty!
								</h2>
							</div>
							<div class="ff-spectral fs-5 text-center d-flex flex-column align-items-center sub-text-margin">
								<ng-container>
									<p class="sub-text">
										Your account has been successfully created and you can now start to enjoy shopping and earning points towards gifts!
									</p>
								</ng-container>
							</div>
							<div class="d-flex flex-column justify-content-center align-items-center text-center mr-4 ml-4 mt-2">
								<p class="footer-text">
									We have sent you a confirmation
                                    email to ({{ email }})
								</p>
								<div *ngIf="
                                        (accountType$ | async) === 'customer';
                                        else tradeButtons
                                    "
									class="row mt-4">
									<div class="col-6 text-center">
										<a [routerLink]="['/']"
											class="btn btn-outline-primary">
											Continue shopping
										</a>
									</div>
									<div class="col-6 text-center">
										<a [routerLink]="['/account']"
											class="btn btn-primary">
											Go to dashboard
										</a>
									</div>
								</div>
								<ng-template #tradeButtons>
									<a [routerLink]="['/']"
										class="btn btn-primary mt-4">
										<span>Homepage</span>
										<svg-icon class="btn-right-arrow"
											src="assets/images/icon-arrow-right-white.svg"></svg-icon>
									</a>
								</ng-template>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
